// an attempt to create a high order component for b-modal

import { mapGetters } from 'vuex'
import { LTileLayer } from 'vue2-leaflet'
import { getMapMode } from '@/shared/constants/maps'

const defaultMapUrl = getMapMode('dark');

export default {
  name: 'l-tile-layer-custom',

  extends: LTileLayer,

  props: {
    url: {
      type: String,
      default: function () {
        const theme = this.$store.state.gui.darkMode ? 'dark' : 'light';
        return getMapMode(theme) || defaultMapUrl;
      },
    },

    attribution: {
      type: String,
      default: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    },
  },

  computed: {
    ...mapGetters('gui', [
      'darkMode',
    ]),
  },

  watch: {
    darkMode: {
      immediate: true,
      handler: function (value) {
        const theme = value ? 'dark' : 'light';
        this.$emit('update:url', getMapMode(theme) || defaultMapUrl);
      },
    },
  },
};
